






















import { computed, defineComponent } from "@vue/composition-api";
import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";
import { isTipMessageDetails } from "@scrile/api-provider/dist/api/TipProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import BaseIcon from "@/components/BaseIcon";
import FormatMoney from "@/components/FormatMoney";
import LiveChatUserAvatar from "../../../../components/LiveChatUserAvatar";

export default defineComponent({
  name: "StreamMessage",
  components: { LiveChatUserAvatar, FormatMoney, BaseIcon },
  props: {
    message: { type: Object as () => Message, required: true },
    referrersMap: { type: Object as () => Record<string, UserPublicData>, default: () => ({}) },
  },
  setup(props) {
    const amount = computed<number>(() =>
      isTipMessageDetails(props.message.details) ? props.message.details.amount : 0
    );

    return {
      amount,
    };
  },
});
